/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 実施処置
 */
export type TreatmentExecuteTreatmentEnum =
  (typeof TreatmentExecuteTreatmentEnum)[keyof typeof TreatmentExecuteTreatmentEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentExecuteTreatmentEnum = {
  BLOOD_GLU_MEASUREMENT: 'BLOOD_GLU_MEASUREMENT',
  GLUCOSE: 'GLUCOSE',
  IV_ACCESS_BEFORE_CPA: 'IV_ACCESS_BEFORE_CPA',
  AIRWAY_ESTABLISHMENT: 'AIRWAY_ESTABLISHMENT',
  ADRENALINE_IV_CPA: 'ADRENALINE_IV_CPA',
  ADRENALINE_IM_ANAPHYAXIS: 'ADRENALINE_IM_ANAPHYAXIS',
  EPIPEN: 'EPIPEN',
  ACP: 'ACP',
} as const;
